import React from 'react';
import PropTypes from 'prop-types';
import { ComponentWrapper, ComponentVerticalSpacing, Svg } from 'day8-react/build/new-components';
import DestinationSvg from './Svg';

const Overview = ({ data }) => (
  <ComponentVerticalSpacing noBottom className="tsw-c-overview d8-u-bg-img padding-bottom-xl">
    <ComponentWrapper>
      <div className="grid grid-gap-xxl">
        <div className="col-7@md">
          <div className="overview-decoration">
            <div><DestinationSvg className="dots-svg" name="dots" fill="#06A7A3" /></div>
            <div className="decoration-square" />
            <div><img className="d8-u-radius-md" src={data.image_landscape.url} alt={data.image_landscape.alt} /></div>
            <div><img className="d8-u-radius-md" src={data.image_portrait.url} alt={data.image_portrait.alt} /></div>
          </div>
        </div>

        <div className="col-5@md self-center">
          <div className="grid grid-gap-md overview-items">
            {data.items && data.items.map((item, i) => (
              <div key={i} className="col-12 text-component overview-items__item">
                <div className="d8-u-primary-bg d8-u-radius-lg inline-flex padding-x-md padding-y-xs item-icon__wrapper">
                  <Svg className="icon--md" name={item.icon} />
                </div>
                <h3 className="text-md">{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  </ComponentVerticalSpacing>
);

Overview.propTypes = {
  data: PropTypes.object
};

export default Overview;
